import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import SelectableRowGroup from '../../SelectableRowGroup/SelectableRowGroup';
import { SelectableRowType } from '../../SelectableRowGroup/types';
import { getError } from '../utils';

type Props = {
  rows: SelectableRowType[];
  fieldName: string;
  onChange: (value: { [key: string]: SelectableRowType }) => void;
  defaultActiveButton?: string;
};

export const SelectableRowGroupForm: React.FC<
  React.PropsWithChildren<Props>
> = ({ rows, fieldName, onChange, defaultActiveButton = '' }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const [activeButton, setActiveButton] = React.useState(defaultActiveButton);

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field }) => (
        <SelectableRowGroup
          size="sm"
          list={rows}
          isValid={!getError(fieldName, errors)}
          activeButton={activeButton}
          onClick={(row) => {
            const value = activeButton !== row.value ? row.value : '';
            setActiveButton(value);
            field.onChange(value);
            onChange({ [fieldName]: row });
          }}
        />
      )}
    />
  );
};
